import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { Dialog, Dropdown, v2Api } from 'moovila-common';

import { changeUserEnterprise, isLoading } from '../../actions';

import CheckForDirtyUtility from '../../utilities/checkForDirty';

class TransferUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidMove: false,
      enterpriseGUID: '',
    };
    this.getUser = this.getUser.bind(this);
    this.save    = this.save.bind(this);
  }

  componentWillMount() {
    const freshState = {enterpriseGUID: this.props.enterpriseGUID};
    
    this.setState(freshState);
    this.checkForDirty = CheckForDirtyUtility(freshState);

    this.props.isLoading(true);
    v2Api
      .fetch('User/CheckForUserActivity', {userGUID: this.props.primaryGUID})
      .then(({data}) => {
        this.props.isLoading(false);
        if (data.hasActivity) {
          this.setState({invalidMove: true});
          this.props.showMessageBox({
            title: 'Cannot Move User',
            message: 'This user has activity in their current enterprise. They cannot be moved.',
          });
        }
      })
  }

  getUser(userGUID) {
    return this.props.users.find(u => u.userGUID === userGUID);
  }

  save() {
    if (this.state.enterpriseGUID === this.props.enterpriseGUID) {
      return;
    }
    this.props.changeUserEnterprise(this.props.primaryGUID, this.state.enterpriseGUID, this.props.enterpriseGUID);
  }

  render() {
    const backTo = `/admin/enterprise-maintenance/users/${this.props.enterpriseGUID}`;
    if (this.state.invalidMove) {
      return <Redirect to={backTo} />;
    }
    if (this.props.loading) {
      return null;
    }
    return (
      <Dialog
        size='md'
        title='Move User'
        yesCallback={this.save}
        yesText='Move'
        backTo={backTo}
        noCallback={(e) => {
          if (this.checkForDirty.test(e, this.state)) {
            e.preventDefault();
            this.props.setQuestion({
              title: 'Unsaved Changes',
              message: 'You have unsaved changes. Are you sure you want to leave this page?',
              yesCallback: () => this.props.history.push(backTo),
            });
          }
        }}
      >
        <h1>Choose New Enterprise</h1>
        <div className='form-control' style={{position: 'relative'}}>
          <Dropdown
            items={this.props.enterprises}
            itemKey='enterpriseGUID'
            selectedKey={this.state.enterpriseGUID}
            formatSelectedItem={enterprise => <div style={{paddingTop: 3}}>{enterprise.enterpriseName}</div>}
            onChange={enterprise => this.setState({enterpriseGUID: enterprise.enterpriseGUID})}
            listRenderer={(enterprise, i, onListItemClick) => <li className='Dropdown__List-Item row' key={i} onClick={() => onListItemClick(enterprise)}>{enterprise.enterpriseName}</li>}
            searchOnKeys={['enterpriseName']}
            listSorter={(a, b) => {
              if (a.enterpriseName.toLowerCase() < b.enterpriseName.toLowerCase()) {
                return -1;
              }
              if (a.enterpriseName.toLowerCase() > b.enterpriseName.toLowerCase()) {
                return 1;
              }
              return 0;
            }}
          />
        </div>
        <div className='row' style={{marginTop: 24}}>
          <div className='col-xs-12'>User: <strong>{this.getUser(this.props.primaryGUID).userDisplayName}</strong></div>
        </div>
        <div className='row' style={{marginTop: 6}}>
          <div className='col-xs-12'>Current enterprise: <strong>{this.props.enterpriseName}</strong></div>
        </div>
      </Dialog>
    );
  }
}

export default connect(s => s, {
  changeUserEnterprise,
  isLoading,
})(TransferUser);



// WEBPACK FOOTER //
// ./src/containers/Admin/TransferUser.js